import styled from 'styled-components';

import { HOME } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 14px;
`;

export const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const Dot = styled.span<{ $color: string; $dashed: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  flex-shrink: 0;
  background: ${(p) => (p.$dashed ? 'transparent' : p.$color)};
  border: ${(p) => (p.$dashed ? `1px dashed ${p.$color}` : 'none')};
`;

export const Name = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: ${HOME.t400};
`;
